const PLANNER_TABLES = new Set([
    'planner_jobs',
    'planner_projects',
    'planner_tasks',
    'planner_posts',
    'planner_events',
    'planner_event_categories',
    'planner_library',
    'planner_content_smm',
]);

function isDataImageUrl(value) {
    return typeof value === 'string' && /^data:image\//i.test(value.trim());
}

/** Remove inline base64 image payloads; keep normal URLs/paths as text. */
function stripInlineDataImages(value) {
    if (value == null) return value;
    if (typeof value === 'string') {
        return isDataImageUrl(value) ? '' : value;
    }
    if (Array.isArray(value)) {
        return value.map(stripInlineDataImages);
    }
    if (typeof value !== 'object') return value;

    const out = {};
    Object.entries(value).forEach(([key, child]) => {
        out[key] = stripInlineDataImages(child);
    });
    return out;
}

function sanitizePlannerRow(row) {
    if (!row || typeof row !== 'object') return row;
    return stripInlineDataImages(row);
}

/** Strip only embedded data:image payloads from planner rows. Image URLs/paths are kept. */
export function sanitizePlannerBackupRows(tableName, rows) {
    if (!PLANNER_TABLES.has(tableName)) return rows;
    if (!Array.isArray(rows)) return rows;
    return rows.map(sanitizePlannerRow);
}

export { PLANNER_TABLES };
